import axios from "axios";
import config from "../config";

export function csrfCookie() {
  return axios.get(`${config.api_url}/sanctum/csrf-cookie`);
}

export function getMe() {
  return axios.get(`${config.api_url}/me`);
}

export function updateMe(body) {
  return axios.put(`${config.api_url}/me`, body);
}

export function logout() {
  return axios.post(
    `${config.api_url}/logout`,
    {},
    { headers: { Accept: "application/json" } },
  );
}

export function disconnectService(service) {
  return axios.post(`${config.api_url}/disconnect/${service}`);
}

export function loginDynamics365(body) {
  return axios.post(`${config.api_url}/dynamics365/config`, body);
}
